import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "../utils/api";
import ReleaseCard from "./ReleaseCard";

function SkeletonCard() {
  return (
    <div className="space-y-3">
      <div className="aspect-square skeleton rounded-md" />
      <div className="h-3 skeleton rounded w-4/5" />
      <div className="h-3 skeleton rounded w-3/5" />
    </div>
  );
}

export default function LatestReleases({ onReleaseClick }) {
  const [releases, setReleases] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    api.get("/releases/latest")
      .then((res) => setReleases(res.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="py-16" id="releases">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-baseline justify-between mb-8">
          <div>
            <p className="text-rose-500 text-xs font-bold uppercase tracking-widest mb-1">{t("home.latest_eyebrow")}</p>
            <h2 className="text-3xl sm:text-4xl font-black text-white font-heading">{t("home.latest_title")}</h2>
          </div>
          <Link
            to="/search"
            className="text-zinc-500 hover:text-rose-400 text-sm font-semibold transition-colors flex items-center gap-1 flex-shrink-0"
            data-testid="all-releases-link"
          >
            {t("home.latest_all")}
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6">
          {loading
            ? Array.from({ length: 10 }).map((_, i) => <SkeletonCard key={i} />)
            : releases.map((release) => (
                <ReleaseCard key={release.id} release={release} onClick={onReleaseClick} />
              ))}
        </div>
      </div>
    </section>
  );
}
